module.exports = __webpack_public_path__ + "media/images/iOS@2x-67c5bf66a7fea31e4334e70217c6334d.png";